export default "__VITE_ASSET__e510929a__"